import $ from 'jquery';

/**
 * Created by Beni on 2016. 05. 09..
 */

$(document).ready(function () {
    console.log("frontend: games ready");

    $('#show-all-tabs').click(function () {
      $('#upcomingGamesSection').removeClass("fade").addClass("active");
      $('#pastGamesSection').removeClass("fade").addClass("active");
    });

    $(".game-sport-checkbox").change(function(){
        var url = $(this).data("url");
        location.href = url;
    });
    $(".game-sport-button").click(function(){
        var url = $(this).data("url");
        location.href = url;
    });

    if ($("#series").length > 0) {
        $(".serie-checkbox").change(function () {
            var url = $(this).val();
            location.href = url;
        });
        $(".game-serie-button").click(function () {
            var url = $(this).data("url");
            location.href = url;
        });
    }
    var gamesDates = $("#games-dates");
    if (gamesDates.length > 0) {
        gameSendAjax(gamesDates.data("url"), {"date" : gamesDates.val()});
        $(document).on('change', "#games-dates", function (e) {
            gameSendAjax($(this).data("url"), {"date" : $(this).val()});
        });
    }

    var gamesIpp = $("#game-ipp");
    if (gamesIpp.length > 0) {
        $(document).on('change', "#game-ipp", function (e) {
            gameSendAjax($(this).data("url"), {"ipp" : $(this).val()});
        });
    }

    var gamesPager = $("#game-pager");
    if (gamesPager.length > 0) {
        $(document).on('click', "#game-pager a", function (e) {
            gameSendAjax($(this).data("url"), {"page" : $(this).data("page")});
            return false;
        });
    }
});

function gameSendAjax(url, data) {
    $.ajax({
        type: "GET",
        url: url,
        data: data,
        crossDomain: true,
        headers: {'X-Requested-With':'XMLHttpRequest'},
        success: function (ret) {
            if (ret.html) {
                $("#pastGamesSection").html(ret.html);
            }
        }
    });
}
